<template>
  <div class="youtaofang">
       <topTitle title="钱湖柏庭" :list="list" :newData="newData"></topTitle>
       <p class="top_p"> 东钱湖自古形胜，既有西湖的柔美秀丽，又有太湖的烟波浩淼，享有“西子风韵，太湖气魄”的美誉，是国家旅游度假区。</p>
        <p class="top_p" style="margin:0"> 钱湖柏庭择址于东钱湖畔，福泉山麓，坐拥宁波的湖光山色，所处的福泉山麓是东钱湖负氧离子含量较高的区域之一，也是宁波天然氧吧之一，这样一处世外桃源无疑是长者颐养天年的理想胜地。</p>
        <div class="item_bd">
            <img :src="item.img" alt="" v-for="(item,key) in list2" :key='key'>
        </div>
  </div>
</template>
  <script>
  import topTitle from "../rightTopTitle";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "项目简介",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "项目简介",
        },
        {
          title: "柏庭相册",
          small_title: "BOTING PHOTO ALBUM",
          hasTitle: "柏庭相册",
        },
        {
          title: "项目位置",
          small_title: "PROJECT LOCATION",
          hasTitle: "项目位置",
        },
        {
          title: "新闻中心",
          small_title: "NEW CENTER",
          hasTitle: "新闻中心",
          children: [
            {
              title: "2020",
              id: "1",
            },
            {
              title: "2019",
              id: "2",
            },
            {
              title: "2018",
              id: "3",
            },
          ],
        },
      ],
      newData: 2,
        list2:[{
            img:require('../../assets/image/home/wiezhi.jpeg')
        },
        ]
    };
  },
  methods: {},
  mounted: function() {},
  components: {
      topTitle
  },
   props: {

  },
};
</script>
<style scoped="scoped">
.youtaofang{
    width: 100%;
    height: 100%;

}
.top_p {
margin-top: 0.6625rem;
 text-align: left;
font-size: 0.35rem;
font-family: PingFang SC;
font-weight: 400;
color: #222222;
line-height: 0.675rem;
text-indent: 2em;
}
.item_bd{
    margin-top: 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.item_bd img{
    width: 100%;
    height: auto;
    /* width: 4.0125rem;
height: 3.0125rem;
border-radius: 0.125rem; */

}
</style>